module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-right-circle-5cd2852ae89eae76d5f95b1f5cb3c52c.svg";